import { type AutocompleteRenderOptionState, Checkbox, FormControlLabel, ListItem, Typography } from "@mui/material";
import type { HTMLAttributes } from "react";
import type { TAutocompleteAppellationsOption } from "./index";

export interface IAutocompleteAppellationOptionProps extends HTMLAttributes<HTMLLIElement> {
  label: string;
  selected: boolean;
}

export const AutocompleteAppellationOption = ({ label, selected, ...props }: IAutocompleteAppellationOptionProps) => {
  return (
    <ListItem {...props} sx={{ p: 0 }}>
      <FormControlLabel
        onClick={(event) => event.preventDefault()}
        control={<Checkbox checked={selected} size="small" sx={{ p: 0, ml: 2, mr: 1 }} />}
        label={
          <Typography
            variant="body1"
            sx={{
              color: "black.dark",
            }}
          >
            {label}
          </Typography>
        }
        sx={{ alignItems: "start" }}
      />
    </ListItem>
  );
};

export const renderAutocompleteAppellationOption = (
  { className: _className, ...props }: HTMLAttributes<HTMLLIElement>,
  option: TAutocompleteAppellationsOption,
  state: Pick<AutocompleteRenderOptionState, "selected">
) => <AutocompleteAppellationOption {...props} key={option._id} label={option.libelle} selected={state.selected} />;
